import  { STORE_PUBLISH_FIELD_DETAILS } from '../actions/storePublishFieldDetailsActions';;

interface PublishFields {
    region: string,
    product_id: string,
    product_description: string,
    pricing: number,
    country : string,
    province : string,
    origin: string,
    specification: string,
    currency: string
}

export const storePublishFieldDetailsReducer= (
	state: PublishFields = {
        region: "emea",
        product_id: "51001",
        product_description: "Milk Chocolate",
        currency: '£', 
        pricing: 4.5,
        country : "uk",
        province:"",
        origin: "Belgium",
        specification: "Assorted Belgian Milk Chocolate Truffles. 300g"
    },
	action: {type:string, payload : {key:string, value:string}}
): any => {
	switch (action.type) {
		case STORE_PUBLISH_FIELD_DETAILS:
			return {
                ...state,
                [action.payload.key] :  action.payload.value
            };
		default:
			return state;
	}
}

